<template>
    <section class="menu cid-qTkzRZLJNu" once="menu" id="menu1-0">
        <nav class="navbar navbar-expand beta-menu navbar-dropdown align-items-center navbar-fixed-top navbar-toggleable-sm">
            <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <div class="hamburger">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>
            <div class="menu-logo">
                <div class="navbar-brand">
                    <span class="navbar-logo">
                        <a href="/">
                            <img src="/assets/images/logo.png" alt="go4pro.org" style="height: 3.8rem;">
                        </a>
                    </span>

                </div>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <form @submit.prevent="onSubmit">
                    <!-- <input type="text" placeholder="搜索内容" id="q" name="q" v-model="q"> -->
                    <!-- <input type="hidden" id="p" name="p" value="1" v-model="p"> -->
                    <input type="text" placeholder="搜索内容" id="q" name="q" ref="q">
                    <input type="hidden" id="p" name="p" value="1" ref="p">
                </form>
                <ul class="navbar-nav nav-dropdown" data-app-modern-menu="true">
                    <li class="nav-item">
                        <a class="nav-link link text-white display-4" href="/">
                            <!-- <span class="mbri-home mbr-iconfont mbr-iconfont-btn"></span> -->
                            <span class="fas fa-home"></span>
                            首页
                        </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link link text-white dropdown-toggle display-4" href="https://mobirise.com"
                            data-toggle="dropdown-submenu" aria-expanded="true">
                            <!--<span class="mbri-search mbr-iconfont mbr-iconfont-btn"></span> -->
                            <span class="fas fa-list"></span>
                            分类
                        </a>
                        <CategoryListIndex />
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link link text-white dropdown-toggle display-4" href="https://mobirise.com"
                            data-toggle="dropdown-submenu" aria-expanded="true">
                            <!--<span class="mbri-search mbr-iconfont mbr-iconfont-btn"></span> -->
                            <span class="fas fa-users"></span>
                            作者
                        </a>
                        <AuthorListIndex />
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link link text-white display-4" :to="{name: 'about'}">
                            <!-- <span class="mbri-search mbr-iconfont mbr-iconfont-btn"></span> -->
                            <span class="fas fa-info-circle"></span>
                            关于我们
                        </router-link>
                    </li>
                </ul>
                <!-- <div class="navbar-buttons mbr-section-btn">
                    <a class="btn btn-sm btn-primary display-4" href="https://mobirise.com">
                        <span class="mbri-save mbr-iconfont mbr-iconfont-btn "></span>
                        Try It Now!
                    </a>
                </div> -->
            </div>
        </nav>
    </section>

</template>

<script>
    import CategoryListIndex from '@/components/CategoryListIndex';
    import AuthorListIndex from '@/components/AuthorListIndex';

    export default {
        name: "Navigator",
        components: {
            CategoryListIndex,
            AuthorListIndex,
        },
        methods: {
            onSubmit() {
                //alert(q.value);
                //window.location.href="/content/"+this.q.value+"/"+this.p.value;
                window.location.href="/content/"+this.$refs.q.value+"/"+this.$refs.p.value;
                
                //alert(p.value);
                //alert(q.value);
            }
        }
    };
</script>